import { Popup } from 'Lib/popup/popup';
import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';
import { copytext } from 'Lib/copy-text/copy-text';
import { formatPrice } from 'Lib/format-price/format-price';
import { eventSender } from 'Lib/event-sender/event-sender';
import { isLocalStorageEnabled } from 'Lib/is-local-storage-enabled/is-local-storage-enabled';
import { whiteLabel } from 'Lib/white-label/white-label';

// Блок вместе дешевле

const $body = $('body');
const cPromocode = 'book-page__promoсode';
const $promocodePrice = $('.book-page__promoсode-price');
const $promocodeBtn = $('.book-page__promoсode-btn');
const cPromocodeBtnSuccess = 'book-page__promoсode-btn_success';
const $promocodeBtnText = $promocodeBtn.find('.book-page__promoсode-btn-text');
const $promocodeBtnLoader = $promocodeBtn.find('.book-page__promoсode-btn-loader');
const $promocodeMessage = $('.book-page__promoсode-message');
const $promocodePriceOld = $('.book-page__promoсode-price-old');
const sBookSliderItem = '.books-slider__item';
const promocodeDiscountPercent = Number($('.book-page__promoсode').attr('data-promocode-discount-percent'));
const popup = new Popup('popup', document.querySelector('.book-page__promoсode-popup'));
const arrBook24Id = [];
let promocodePrice = 0;
let promocodePriceWithSale = 0;
let promocodeSale = 0;
const objBooks = {
    'currency': 'RUB',
    'value': 0,
    'items': [],
};

// Установка цены в зависимости от выбранных книг в пакете
function setValuesPromocode(price, sale) {
    $promocodePrice.text(`${price} ₽`);
    objBooks.value = price;

    if (sale) {
        $promocodePriceOld.text(`${price + sale} ₽`).css('display', 'inline');
        $('.book-page__promoсode-text-span_benefit').text(`${sale} ₽`);
        $promocodeMessage.addClass('book-page__promoсode-message_active');
    } else {
        $promocodePriceOld.css('display', 'none');
        $promocodeMessage.removeClass('book-page__promoсode-message_active');
    }
}

// Вычисление и установка цены пакета
$('.books-slider_post-load').on('eksmoBooksSliderPostLoaded', () => {
    if (promocodeDiscountPercent) {
        const prices = $(`.${cPromocode}`).find('.book__price-cur');

        prices.each(function () {
            promocodePrice += Number($(this).attr('data-price'));
        });

        promocodePriceWithSale = promocodePrice - Math.round(promocodePrice * promocodeDiscountPercent);
        promocodeSale = Math.round(promocodePrice * promocodeDiscountPercent);
        setValuesPromocode(promocodePriceWithSale, promocodeSale);

        $('.books-slider_together-cheaper .books-slider__item').each(function () {
            const $th = $(this);
            const price = Number(formatPrice($th.find('.book__price-cur').attr('data-price-sale')));
            const oldPrice = Number(formatPrice($th.find('.book__price-cur').attr('data-price')));
            const discountPrice = oldPrice && (oldPrice !== price) && price ? oldPrice - price : null;

            arrBook24Id.push({
                productId: Number($(this).attr('data-book24')),
                quantity: 1,
            });

            objBooks.items.push({
                'item_name': $th.find('.book__name').text().trim(),
                'item_id': $th.attr('data-id'),
                'discount': discountPrice,
                'price': price,
                'item_brand': $th.attr('data-brand'),
                'item_category': $th.attr('data-first-category'),
                'item_category2': $th.attr('data-last-category'),
                'item_category3': $th.attr('data-author'),
                'item_category4': 'Бумажная',
            });
        });
    }
});

// Вычисление и установка цены пакета при изменении его составных частей
$body.on('change', '.book__checkbox-input', function () {
    const $parent = $(this).closest(sBookSliderItem);
    const currElPrice = Number($parent.find('.book__price-cur').attr('data-price'));
    const saleCurrElPrice = Math.round(currElPrice * promocodeDiscountPercent);
    const currElPriceWithSale = currElPrice - saleCurrElPrice;
    const $radioCheck = $('.book__checkbox-input:checked');
    const book24Id = $parent.attr('data-book24');

    if ($(this).is(':checked')) {
        promocodePrice += currElPrice;
        promocodePriceWithSale += currElPriceWithSale;
        promocodeSale += saleCurrElPrice;
        arrBook24Id.push(book24Id);
    } else {
        promocodePrice -= currElPrice;
        promocodePriceWithSale -= currElPriceWithSale;
        promocodeSale -= saleCurrElPrice;
        arrBook24Id.splice(arrBook24Id.indexOf(book24Id), 1);
    }

    if ($radioCheck.length === 1) {
        $promocodeBtn.removeClass('btn_disabled');
        $promocodeBtnText.text('В корзину');
        setValuesPromocode(promocodePrice);
    } else if ($radioCheck.length === 0) {
        $promocodeBtn.addClass('btn_disabled');
        setValuesPromocode(0);
    } else {
        $promocodeBtnText.text('В корзину комплектом');
        setValuesPromocode(promocodePriceWithSale, promocodeSale);
    }
});

// Событие при клике на иконку копирования промокода
$('.book-page__promoсode-copy-icon').on('click', () => {
    copytext('.book-page__promoсode-promocode');

    if (getW() < eksmoBP.xsMax) {
        popup.open();
    }
});

$promocodeBtn.on('click', () => {
    if (!$promocodeBtn.hasClass(cPromocodeBtnSuccess)) {
        const textBtnBasket = $promocodeBtnText.text().trim();

        $promocodeBtnLoader.addClass('book-page__promoсode-btn-loader_active');
        $promocodeBtnText.text('');

        if (arrBook24Id.length > 0) {
            const basketId = localStorage.getItem('BASKET_ID');

            if (basketId) {
                whiteLabel.applyPromocode($('.book-page__promoсode-text-span_promocode').text())
                    .then(() => {
                        whiteLabel.addBookBasketTogether(arrBook24Id)
                            .then(() => {
                                eventSender.addSomeBookGA4(objBooks, textBtnBasket);
                                $promocodeBtnLoader.removeClass('book-page__promoсode-btn-loader_active');
                                $promocodeBtnText.text('Оформить');
                                $promocodeBtn.attr('href', 'https://eksmo.ru/cart/#/personal/cart').addClass(cPromocodeBtnSuccess);
                            })
                            .catch(() => console.error('Ошибка в добавлении книг комплектом'));
                    });
            }
        }
    }
});